<template>
	<div class="list-cards">
		<div class="cards-img">
			<img :src="promotionBlock.image" :alt="promotionBlock.name" class="img-fluid">
		</div>

		<div class="cards-body">
			<router-link class="itemLink" :to="`/product/${promotionBlock.id}`">
				<h2>{{ promotionBlock.name }}</h2>
			</router-link>
			<div class="info">
				<template 
					v-for="(product, productIndex) in promotionBlock.products" 
					:key="productIndex"
				>
					<template v-if="!!product.link">
						<p class="items">
							<router-link :to="product.link" class="link">{{ product.erp_name }}</router-link>
							x {{ product.num }}
						</p>
					</template>

					<p  v-else class="items">
						{{ product.erp_name }} x {{ product.num }}
					</p>
				</template>
			</div>

			<div class="price">
				<div class="original">
					<span class="symbol">原價 NT$</span>
					<span class="money">{{ $filters.currency(promotionBlock.price + promotionBlock.discount) }}</span>
				</div>
				<div class="special">
					<span class="symbol">NT$</span>
					<span class="money">{{ $filters.currency(promotionBlock.price) }}</span>
				</div>
			</div>

			<div class="btns-quantity">
				<label :for="`quantity_${promotionBlock.id}`">數量</label>
				<Quantity :id="`quantity_${promotionBlock.id}`" v-model="quantity" :stock="promotionBlock.stock" :max="promotionBlock.buy_limit" />
				<div v-if="promotionBlock.stock < 1" class="remind"><span>商品缺貨中</span></div>
				<div v-else-if="promotionBlock.stock < promotionBlock.alarm" class="remind">低於<span>{{ promotionBlock.alarm }}</span>件</div>
			</div>

			<div class="btns-cart">
				<!-- 庫存足夠時顯示 -->
				<template v-if="promotionBlock.stock > 0">
					<SlidEffectButton id="add_cart" class="btn btn-icon" @click="addPromotion('add', promotionBlock)">
						<BIconCart3 /><span>加入購物車</span>
					</SlidEffectButton>
					<SlidEffectButton id="go_buy" class="btn btn-icon" @click="addPromotion('buy', promotionBlock)">
						<BIconCheckAll /><span>立即結帳</span>
					</SlidEffectButton>
				</template>
				<!-- 庫存不足時顯示 -->
				<template v-else>
					<SlidEffectButton id="sold_out" class="btn btn-icon" disabled>
						<BIconCart3 /><span>補貨中...</span>
					</SlidEffectButton>
				</template>
			</div>
		</div>
	</div>
</template>
<script>
import Quantity from "@/components/Quantity.vue";
import SlidEffectButton from "@/components/SlidEffectButton.vue";
import { ref } from "vue";
export default {
	components: {
		Quantity,
		SlidEffectButton,
	},
    props: {
		promotionBlock: Object,
		required: true,
	},
	setup(props, context) {
		const quantity = ref(props.promotionBlock.stock > 0 ? 1 : 0);
		const addPromotion = (action, product) => {
			context.emit("addPromotion", {
				action,
				product,
				quantity: quantity.value,
			});
		}
		return {
			quantity,
			addPromotion,
		}
	}
}
</script>
<style lang="scss" scoped>
.list-cards {
	padding: 2rem;
	margin-bottom: 2rem;
	border-bottom: 1px solid $color-black-30;
	@media all and (min-width: 768px) {
		flex: 0 0 50%;
	}
	@media all and (min-width: 1024px) {
		flex: 0 0 33%;
	}

	.cards-img {
		img {
			width: 100%;
			max-width: 300px;
			margin: auto;
			display: block;
			@media all and (min-width: 992px) {
				max-width: 500px;
			}
		}
	}
	.cards-body {
		.info {
			padding-bottom: 1rem;
			.items {
				margin-bottom: 0.2rem;
				color: $color-black-50;
				font-size: 0.95rem;
				.link {
					margin-bottom: 0.2rem;
					color: $color-black-50;
					font-size: 0.95rem;
					text-decoration: underline;
					display: inline-block;
					&:hover {
						color: $brand-green;
					}
				}
			}
			
		}
		.itemLink{
			text-decoration: none;
			h2{
				transition: all 0.2s ease-in;
				&:hover {
					color: $brand-green;
				}
			}
		}

		.price {
			display: flex;
			align-items: flex-end;
			// font-size: 0.9rem;
			.special {
				.money {
					font-size: 1.6rem;
					color: $brand-green;
					line-height: 1;
					padding-left: 0.28rem;
				}
			}
			.original {
				margin-right: 1rem;
				.money {
					text-decoration: line-through;
					padding-left: 0.28rem;
				}
			}
		}

		#add_cart {
			background-color: $brand-green;
			color: #fff;
			margin-bottom: 0.5rem;
		}
		#go_buy {
			background-color: $brand-gray;
			color: #fff;
		}
		#sold_out {
			background-color: $brand-gray;
			color: #fff;
		}
	}
}
</style>